// extracted by mini-css-extract-plugin
export default {"modalContentWrapper":"ChangeTeamSeasonPopup_modalContentWrapper__3nWAa"};